import { jsx as l, jsxs as _ } from "react/jsx-runtime";
import W, { useState as H, useId as u, useEffect as B } from "react";
import { c as h } from "../clsx-OuTLNxxd.js";
import { I as E, A as I } from "../index-EGJl6EpT.js";
import '../Accordion.css';const k = "320px", A = "600px", v = "1025px", P = "_header_3f8pb_32", w = "_triggerElement_3f8pb_36", V = "_indicator_3f8pb_39", $ = "_trigger_3f8pb_36", j = "_contentElement_3f8pb_63", C = "_content_3f8pb_63", M = "_item_3f8pb_72", R = "_dense_3f8pb_72", T = "_primary_3f8pb_77", q = "_secondary_3f8pb_114", t = {
  mobile: k,
  "mobile-wide": "480px",
  tablet: A,
  "tablet-wide": "800px",
  desktop: v,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  header: P,
  triggerElement: w,
  indicator: V,
  trigger: $,
  contentElement: j,
  content: C,
  item: M,
  dense: R,
  primary: T,
  secondary: q
}, D = ({
  indicatorSize: r = "s",
  isOpen: n,
  onChange: e,
  stroke: f = "bold"
}) => {
  const [i, s] = H(n), d = u(), g = u(), a = () => {
    e == null || e(!i), s(!i);
  };
  B(() => {
    n !== i && s(n);
  }, [n]);
  const c = {
    "aria-controls": g,
    "aria-expanded": i,
    "data-state": i ? "open" : "closed",
    id: d,
    onClick: a
  }, p = {
    "aria-labelledby": d,
    className: t.contentElement,
    hidden: !i,
    id: g,
    role: "region"
  };
  return {
    headingProps: c,
    sectionProps: p,
    triggerClass: t.triggerElement,
    Indicator: () => f === "bold" ? /* @__PURE__ */ l(E, { className: t.indicator, size: r }) : /* @__PURE__ */ l(I, { className: t.indicator, size: r })
  };
}, z = ({
  chevronStroke: r = "bold",
  children: n,
  classNames: e,
  heading: f,
  indicatorSize: i = "s",
  isDense: s = !1,
  isOpen: d = !1,
  onChange: g,
  trackingAttribute: a
}) => {
  const { Indicator: c, headingProps: p, sectionProps: m, triggerClass: b } = D({
    isOpen: d,
    onChange: g,
    indicatorSize: i,
    stroke: r
  });
  return /* @__PURE__ */ _("div", { className: h(t.item, { [t.dense]: s }, e == null ? void 0 : e.wrapper), children: [
    /* @__PURE__ */ l("h3", { className: h(t.header, e == null ? void 0 : e.header), children: /* @__PURE__ */ _(
      "button",
      {
        className: h(b, t.trigger, e == null ? void 0 : e.button),
        ...p,
        ...a ? { "data-analytics": a } : {},
        children: [
          f,
          /* @__PURE__ */ l(c, {})
        ]
      }
    ) }),
    /* @__PURE__ */ l("div", { ...m, className: h(t.content, e == null ? void 0 : e.content), children: n })
  ] });
}, F = ({
  chevronStroke: r = "bold",
  children: n,
  defaultOpen: e,
  indicatorSize: f = "s",
  isDense: i = !1,
  name: s,
  type: d = "single",
  variant: g = "primary"
}) => {
  const a = d === "multiple", c = W.Children.toArray(n), p = e ? c.map(() => !0) : c.map((o) => !!o.props.isOpen), [m, b] = H(p), S = (o, y) => {
    let x = [];
    a ? (x = [...m], x[y] = o) : (x = c.map(() => !1), o === !0 && (x[y] = !0)), b(x);
  };
  return /* @__PURE__ */ l("div", { className: h(t.accordion, t[`${g}`]), "data-testid": "accordion-component", children: n && c.map((o, y) => /* @__PURE__ */ l(
    z,
    {
      chevronStroke: r,
      classNames: o.props.classNames,
      heading: o.props.heading,
      indicatorSize: f,
      isDense: i,
      isOpen: m[y],
      onChange: (x) => S(x, y),
      trackingAttribute: o.props.trackingAttribute,
      children: o.props.children
    },
    `${s}-item-${y}`
  )) });
};
F.Item = z;
export {
  F as Accordion,
  D as useToggle
};
